export const PAYROLL_TARGET_FILTER = 'payroll_target';

function toYmd(value) {
  return value ? String(value).slice(0, 10) : null;
}

export function isPayrollTargetForPeriod(record, period) {
  if (!record || !period) return true;
  const periodStart = toYmd(period.period_start);
  const periodEnd = toYmd(period.period_end);
  const hireDate = toYmd(record.hire_date);
  const resignDate = toYmd(record.resign_date);

  if (hireDate && periodEnd && hireDate > periodEnd) return false;
  if (resignDate && periodStart && resignDate < periodStart) return false;
  return true;
}

export function payrollFilterLabel(value) {
  return value === 'all' ? '전체(퇴직 포함)' : '급여대상';
}
